import { render, staticRenderFns } from "./ProductOverview2.vue?vue&type=template&id=c4a162f6&"
import script from "./ProductOverview2.vue?vue&type=script&lang=js&"
export * from "./ProductOverview2.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverview2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
